<template>
  <div id="Inspections">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-card-title v-if="userLogged.roles">
            <v-spacer></v-spacer>
            <v-btn
              v-if="userLogged.roles[0].id !== 1"
              class="mr-2"
              @click="downloadReports"
              :loading="loadingReport"
              :disabled="loadingReport || selected.length === 0"
              color="primary">
              {{$t('general.reports')}}
              <v-icon
                small
                class="ml-2">
                fas fa-cloud-download-alt
              </v-icon>
            </v-btn>
            <v-btn
              v-if="userLogged.roles[0].id === 1 || userLogged.roles[0].id === 2 || userLogged.roles[0].id === 3"
              class="mr-2"
              @click="filterModal = true"
              color="primary">
              {{$t('reports.filter')}}
              <v-icon
                small
                class="ml-2">
                  fas fa-align-center
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-overlay absolute opacity="0" :value="loadTable"/>
            <v-data-table
              :show-select="userLogged && userLogged.roles && userLogged.roles.length > 0 && userLogged.roles[0].id !== 1"
              v-model="selected"
              :headers="headers"
              :items="inspections"
              :options.sync="options"
              :footer-props="{ 'items-per-page-options': [50, 70, 100] }"
              :server-items-length="options.total"
              :loading="loadTable"
              @update:page="get"
              @update:items-per-page="get"
              @update:sort-by="get"
              @update:sort-desc="get">
              <!-- ✅ Checkbox de CABECERA controlado -->
              <template v-slot:header.data-table-select>
                <v-simple-checkbox
                  :value="isAllChecked"
                  :indeterminate="isIndeterminate"
                  @input="toggleAll($event)"
                />
              </template>
              <template v-slot:item="props">
                <tr v-if="userLogged && userLogged.roles && userLogged.roles[0].id === 1">
                  <!-- Si el usuario es SuperAdmin -->
                  <td align="left">{{ props.item.name }}</td>
                  <td align="left">{{ props.item.total_inspections }}</td>
                  <td align="left">{{ props.item.date_last_inspection }}</td>
                  <td align="left">{{ props.item.subscription_expiration }}</td>
                </tr>
                <tr v-else>
                  <td align="center">
                    <v-checkbox v-if="visibleCheck(props.item)"
                      v-model="selected"
                      :value="props.item"
                      hide-details
                      style="margin: 0px; padding: 0px"
                    ></v-checkbox>
                  </td>
                  <td align="left">{{ props.item.consecutive_number }}</td>
                  <td align="left">{{ props.item.created_at }}</td>
                  <td align="left">{{ props.item.user.name || '' }} {{ props.item.user.last_name || '' }}</td>
                  <td align="left">
                    {{ props.item.current_operator || (props.item.operator ? props.item.operator[0].name : props.item.current_operator) }}
                  </td>
                  <td align="left" style="font-size:12px" class="px-0">
                    <ol v-for="(plate, i) in props.item.truck" :key="i">
                      <span>{{$t('general.noEco')}}:</span>
                      {{ props.item.truck && (props.item.truck.unit_number !== null && props.item.truck[0].unit_number !== '') ? props.item.truck[0].unit_number : 'N/A' }}
                      <br>
                      <span>{{$t('general.plates')}}:</span>
                      {{ plate.plate_number }}
                    </ol>
                  </td>
                  <td align="left" style="font-size:12px" class="px-0">
                    <ol v-for="(plate, i) in props.item.container" :key="i">
                      <span>{{$t('general.noEco')}}:</span>
                      {{ props.item.container && (props.item.container[0].unit_number !== null && props.item.container[0].unit_number !== '') ? props.item.container[0].unit_number : 'N/A' }}
                      <br>
                      <span>{{$t('general.plates')}}:</span>
                      {{ plate.plate_number }}
                    </ol>
                  </td>
                  <td align="left">{{ props.item.duration }}</td>
                  <td align="left">{{ translateTransit(props.item.transit) }}</td>
                  <td align="left">{{ props.item.site.name }}</td>
                  <td align="left">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip small color="grey" class="white--text" v-bind="attrs" v-on="on">{{ getDamage(props.item).total }}</v-chip>
                      </template>
                      <p class="mb-0"><v-chip small color="info">{{$t('monitoring.low')}}: {{ getDamage(props.item).leve }}</v-chip></p>
                      <p class="mb-0"><v-chip small color="warning">{{$t('monitoring.warning')}}: {{ getDamage(props.item).moderado }}</v-chip></p>
                      <p class="mb-0"><v-chip small color="error">{{$t('monitoring.high')}}: {{ getDamage(props.item).alto }}</v-chip></p>
                    </v-tooltip>
                  </td>
                  <td align="left" v-if="userLoggedCompanies() === 21 || userLoggedCompanies() === 20">
                    <!-- Diseño para la compañía con ID 21 -->
                    <div v-if="userLoggedCompanies() === 21" style="display: flex; flex-wrap: wrap; gap: 5px;">
                      <div 
                        v-for="(section, index) in props.item.sections" 
                        :key="index" 
                        style="display: flex; align-items: center; min-width: 120px; margin-bottom: 5px; font-size: 0.9em;"
                      >
                        <span style="margin-right: 4px;"><strong>{{ $t('general.section') }}:</strong> {{ section.name }}</span>
                        <v-chip
                          small
                          :color="section.status === 0 && areAllAnswersNull(section.questions) ? 'grey' : (section.status === 0 ? 'green' : 'red')"
                          class="white--text"
                          style="display: flex; justify-content: center; align-items: center; height: 20px; font-size: 0.8em; padding: 0 8px; min-width: 70px; text-align: center;"
                        >
                          {{ section.status === 0 && areAllAnswersNull(section.questions) ? 'N/A' : (section.status === 0 ? $t('general.approved') : $t('general.refused')) }}
                        </v-chip>
                      </div>
                    </div>

                    <!-- Diseño original para la compañía con ID 20 -->
                    <div v-else-if="userLoggedCompanies() === 20">
                      <div v-for="(section, index) in props.item.sections" :key="index" style="margin-bottom: 10px;">
                        <div>
                          <strong>{{$t('general.section')}}:</strong> {{ section.name }}
                        </div>
                        <div>
                          <strong>{{$t('general.status')}}:</strong>
                          <v-chip
                            small
                            :color="section.status === 0 && areAllAnswersNull(section.questions) ? 'grey' : (section.status === 0 ? 'green' : 'red')"
                            class="white--text"
                          >
                            {{ section.status === 0 && areAllAnswersNull(section.questions) ? 'N/A' : (section.status === 0 ? $t('general.approved') : $t('general.refused')) }}
                          </v-chip>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td align="center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon class="mr-4" small @click="edit(props.item.id)" v-on="on">far fa-eye</v-icon>
                      </template>
                      <span>{{$t('general.view')}}</span>
                    </v-tooltip>
                    <v-tooltip v-if="canDelete" bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small @click="remove(props.item)" v-on="on">far fa-trash-alt</v-icon>
                      </template>
                      <span>{{$t('general.remove')}}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="500px">
      <v-card>
        <v-toolbar color="grey lighten-5" flat class="mb-5">
          <h3 class="error--text">{{$t('inspections.deleteTitle')}}</h3>
        </v-toolbar>
        <v-card-text>
          <p>{{$t('inspections.delMessage')}}?</p>
          <p><span class="font-weight-black error--text">{{$t('general.inspection')}}: </span> {{removedItem.consecutive_number}}</p>
          <p><span class="font-weight-black error--text">{{$t('general.user')}}: </span> {{removedItem.user.name + ' ' + removedItem.user.last_name}}</p>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="error" text @click="close">{{$t('general.cancel')}}</v-btn>
          <v-btn color="error" :loading="loading" :disabled="loading" depressed @click="confirmRemove">{{$t('general.accept')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      max-width="500px"
      persistent
      v-model="filterModal">
      <v-card>
        <v-card-title>
          <span class="primary--text">{{$t('reports.filter')}}</span>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form
            lazy-validation
            ref="form"
            v-model="valid">
            <v-row dense>
              <!-- Campo de clientes solo para SuperAdmin -->
              <v-col v-if="userLogged.roles[0].id === 1" cols="12">
                <v-autocomplete
                  clearable
                  outlined
                  dense
                  :items="companies"
                  item-text="name"
                  item-value="id"
                  v-model="filter.company_id"
                  :label="$t('general.customer')"
                />
              </v-col>

              <!-- Campos para roles que no son SuperAdmin -->
              <template v-if="userLogged.roles[0].id !== 1">
                <!-- Campos para otros roles excepto Inspectores -->
                <template v-if="userLogged.roles[0].id !== 3">
                  <v-col cols="12">
                    <v-autocomplete
                      clearable
                      outlined
                      dense
                      :items="sites"
                      item-text="name"
                      item-value="id"
                      v-model="filter.site_id"
                      :label="$t('general.site')"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      clearable
                      outlined
                      dense
                      :items="unitTypes"
                      item-text="alias"
                      item-value="id"
                      v-model="filter.unit_type_id"
                      :label="$t('general.unitType')"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      dense
                      :label="$t('general.plates')"
                      :rules="rules.textNoSpecialCharsFilters"
                      v-model="filter.plate"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      dense
                      :label="$t('general.unitNumber')"
                      :rules="rules.textNoSpecialChars"
                      v-model="filter.unit_number"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      dense
                      label="VIN"
                      :rules="rules.textNoSpecialChars"
                      v-model="filter.vin_number"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      clearable
                      outlined
                      dense
                      :items="getTypeTransit()"
                      item-text="text"
                      item-value="value"
                      v-model="filter.type_transit"
                      :label="$t('general.typeTransit')"
                    />
                  </v-col>
                </template>

                <!-- Campos solo para Inspectores (id = 3) -->
                <template v-if="userLogged.roles[0].id === 3">
                  <v-col cols="12">
                    <v-autocomplete
                      clearable
                      outlined
                      dense
                      :items="sites"
                      item-text="name"
                      item-value="id"
                      v-model="filter.site_id"
                      :label="$t('general.site')"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      clearable
                      outlined
                      dense
                      :items="unitTypes"
                      item-text="alias"
                      item-value="id"
                      v-model="filter.unit_type_id"
                      :label="$t('general.unitType')"
                    />
                  </v-col>
                </template>
              </template>

              <!-- Rango de fecha para todos los roles -->
              <v-col cols="12">
                <v-checkbox
                  class="mt-0"
                  hide-details
                  color="primary"
                  :label="$t('general.dateRange')"
                  v-model="filter.dateRange"
                />
              </v-col>
              <v-col v-if="filter.dateRange" cols="6">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filter.start_date"
                      :label="$t('general.startDate')"
                      outlined
                      dense
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      :error-messages="filter.start_date ? '' : $t('validation.startDate')"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker no-title color="primary" v-model="filter.start_date" @input="menu = false"/>
                </v-menu>
              </v-col>
              <v-col v-if="filter.dateRange" cols="6">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filter.end_date"
                      :label="$t('general.endDate')"
                      outlined
                      dense
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      :error-messages="filter.end_date ? '' : $t('validation.endDate')"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker no-title color="primary" v-model="filter.end_date" @input="menu2 = false"/>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn
                  depressed
                  class="float-right"
                  @click="applyFilter"
                  color="primary"
                >
                  {{$t('general.save')}}
                </v-btn>
                <v-btn
                  class="float-right mr-2"
                  outlined
                  @click="close"
                  color="primary"
                >
                  {{$t('general.cancel')}}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'Inspections',
  data () {
    return {
      soft: null,
      moderate: null,
      high: null,
      loadingReport: false,
      valid: false,
      selected: [],
      addDialog: false,
      filterModal: false,
      filter: {
        site_id: null,
        unit_type_id: null,
        plate: null,
        unit_number: null,
        vin_number: null,
        dateRange: false,
        start_date: null,
        end_date: null,
        type_transit: null,
        company_id: null
      },
      menu: false,
      menu2: false,
      unitTypes: [],
      companies: [],
      sites: [],
      loadTable: true,
      loading: false,
      dialog: false,
      pageCount: 0,
      editedItem: {
        site: {
          name: ''
        },
        users: ''
      },
      defaultItem: {
        site: {
          name: ''
        },
        users: ''
      },
      options: {
        page: 1,
        itemsPerPage: 25,
        total: 0
      },
      removedItem: {
        user: {
          name: ''
        }
      },
      inspections: [],
      dateValidation: new Date('2025-12-20 22:00:00')
    }
  },
  created () {
    this.get()
    this.getComplement()
  },
  watch: {
    userLogged () {
      if (this.userLogged.roles) {
        this.get()
        this.getComplement()
      } 
    },
    inspections (val) {
      if (val.length > 0) this.selected = []
    },
  },
  computed: {
     validItems () {
      return this.inspections.filter(item => {
        if (!this.visibleCheck(item)) return false
        const rowDate = new Date(String(item.created_at).replace(' ', 'T'))
        return rowDate > this.dateValidation
      })
    },
    isAllChecked () {
      return this.validItems.length > 0 && this.selected.length === this.validItems.length
    },
    isIndeterminate () {
      return this.selected.length > 0 && this.selected.length < this.validItems.length
    },
    rules () {
      return this.$validationRules()
    },
    headers() {
    // Verificamos si `userLogged` y `roles` están definidos y tienen al menos un elemento
    if (this.userLogged && this.userLogged.roles && this.userLogged.roles.length > 0 && this.userLogged.roles[0].id === 1) {
      // Si es SuperAdmin, mostramos solo las 4 columnas específicas
      return [
        {
          text: this.$t('general.customer'),
          value: 'name',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('inspections.count'),
          value: 'total_inspections',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.dateLastInspection'),
          value: 'date_last_inspection',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.subscriptionExpirationDate'),
          value: 'subscription_expiration',
          align: 'left',
          sortable: true
        }
      ];
    } else {
      // Si no es SuperAdmin, retornamos las columnas actuales
      return [
        {
          text: '#',
          align: 'left',
          sortable: true,
          value: 'consecutive_number'
        },
        {
          text: this.$t('general.date'),
          value: 'created_at',
          align: 'left',
          sortable: true
        },
        {
          text: 'Inspector',
          value: 'user',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.operator'),
          value: 'current_operator',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('unit.title') + " " + 1,
          value: 'truck.vin_number',
          align: 'center',
          sortable: true
        },
        {
          text: this.$t('unit.title') + " " + 2,
          value: 'container.vin_number',
          align: 'center',
          sortable: true
        },
        {
          text: this.$t('general.duration'),
          value: 'duration',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.typeTransit'),
          value: 'transit',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.site'),
          value: 'site',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.damage'),
          align: 'left',
          sortable: true
        },
        // Solo agregamos la columna de status si es la compañía con ID 20 y ID 21
        ...(this.userLoggedCompanies() === 20 || this.userLoggedCompanies() === 21 ? [{
          text: this.$t('general.status'),
          align: 'center',
          sortable: true,
        }] : []),
        {
          text: this.$t('general.actions'),
          align: 'left',
          sortable: false
        }
      ];
    }
    },
    userLogged () {
      return this.$store.state.userLogged
    },
    canDelete () {
      if (this.userLogged.roles && this.userLogged.roles[0].id === 2) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    isSelectedRow (item) {
      // compara por id (más estable que referencia)
      return this.selected.some(s => s.id === item.id)
    },

    toggleRow (item, checked) {
      const allowed = this.validItems.some(v => v.id === item.id)
      if (!allowed) return

      if (checked) {
        if (!this.isSelectedRow(item)) this.selected = [...this.selected, item]
      } else {
        this.selected = this.selected.filter(s => s.id !== item.id)
      }
    },

    toggleAll (checked) {
      this.selected = checked ? [...this.validItems] : []
    },
    visibleCheck(item){
      // VALIDA POR LA FECHA ESTABLECIDA POR CUESTIÓN DEL BACK
      return (new Date(item.created_at) >= this.dateValidation)
    },
    getComplement() {
      if (this.userLogged.roles[0].id === 1) {
        this.$store.dispatch('company/get', {event: {item: {perPage: -1, page: 1}, context: this}})
      }
      if (this.userLogged.roles[0].id === 2 || this.userLogged.roles[0].id === 3) {
        this.$store.dispatch('sites/get', { event: {context: this, all: true, item: { perPage: -1, page: 1 } } })
        this.$store.dispatch('unitTypes/getAll', { event: { context: this } })
      }
    },
    areAllAnswersNull(questions) {
      return questions.every(question => question.answer === null);
    },
    userLoggedCompanies() {
      if (this.$store.state.userLogged && this.$store.state.userLogged.companies && this.$store.state.userLogged.companies.length > 0) {
        return this.$store.state.userLogged.companies[0].id;
      } else {
        return null;
      }
    },
    downloadReports () {
      this.loadingReport = true
      let item = this.selected.map(e => { return { 'id' : e.id } })
      this.$store.dispatch('inspections/getReports', {
        event: {
          context: this,
          inspections: item
        }
      })
    },
    getDamage (item) {
      let damage = []
      let soft = []
      let moderate = []
      let high = []
      //COMENTADO POR CAMBIO EN LA ESTRUCTURA DE DATOS
      // item.forEach(e => {
      //   e.questions.forEach(a => {
      //     if (a.damage_level !== 'NONE') {
      //       damage.push(a.damage_level)
      //     }
      //     if (a.damage_level === 'SOFT') {
      //       soft.push(a.damage_level)
      //     }
      //     if (a.damage_level === 'MODERATE') {
      //       moderate.push(a.damage_level)
      //     }
      //     if (a.damage_level === 'HARD') {
      //       high.push(a.damage_level)
      //     }
      //   })
      // })
      const total = Number(item.soft) + Number(item.moderate) + Number(item.hard)
      const leve = item.soft
      const moderado = item.moderate
      const alto = item.hard
      return { total, leve, moderado, alto }
    },
    close () {
      this.dialog = false
      this.addDialog = false
      this.loading = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.removedItem = {
        user: {
          name: ''
        }
      }
      if(this.$refs.form) this.closeFilter()
    },
    closeFilter() {
      this.filterModal = false
      this.filter = {
        site_id: null,
        unit_type_id: null,
        plate: null,
        unit_number: null,
        vin_number: null,
        dateRange: false,
        start_date: null,
        end_date: null,
        type_transit: null,
        company_id: null
      },
      this.$refs.form.resetValidation()
    },
    addUsers (item) {
      this.editedItem = Object.assign({}, item)
      if (this.editedItem.users.length < 1) {
        this.editedItem.users = ''
      }
      this.addDialog = true
    },
    saveUsers () {
      if (this.$refs.form.validate()) {
        this.showNotification('Usuarios relacionados correctamente', 'success')
      }
    },
    edit (id) {
      this.$router.push('inspections/view/' + id)
    },
    remove (item) {
      this.removedItem = item
      this.dialog = true
    },
    confirmRemove () {
      this.loading = true
      this.$store.dispatch('inspections/delete', {event: {id: this.removedItem.id, context: this}})
    },
    applyFilter () {
      if(!this.$refs.form.validate()) return
      
      if (this.filter.dateRange) {
        if (this.filter.start_date && this.filter.end_date) {
          this.get()
          this.filterModal = false
        }
      } else {
        this.get()
        this.filterModal = false
      }
    },
    get() {
    this.loadTable = true;
      if (this.userLogged.roles) {
      let eventPayload = {
        perPage: this.options.itemsPerPage,
        page: this.options.page,
        ord: this.options.sortDesc && this.options.sortDesc[0] ? 'asc' : 'desc',
        context: this,
        filter: this.filter
      };
      if (this.userLogged.roles[0].id !== 1) {
        eventPayload = {
          ...eventPayload,
          sortKey: this.options.sortBy ? this.options.sortBy[0] : 'id',
          type: 'json'
        };
      }
      this.$store.dispatch('inspections/get', { event: eventPayload })
        .then(() => {
        })
      }
    },
    translateTransit(value) {
      const typeTransit = {
        'INPUT': this.$t('inspections.input'),
        'OUTPUT': this.$t('inspections.output'),
        'ON_ROUTE': this.$t('inspections.on_route')
      };
      return typeTransit[value] || 'N/A';
    },
    getTypeTransit() {
      return [
        { value: 'INPUT', text: this.$t('inspections.input') },
        { value: 'OUTPUT', text: this.$t('inspections.output') },
        { value: 'ON_ROUTE', text: this.$t('inspections.on_route') },
      ];
    }
  }
}
</script>